<template lang="pug">
li(@click="toggleOpen()" :class="{active: active, open:open}")
  router-link(v-if="item.path" :to="item.path")
    a(:id="item.id") {{item.title}}
  a(v-else="" :id="item.id") {{item.title}}
  ul.sub-menu(v-if="item.sub")
    router-link(v-for="s in item.sub" tag="li" :to="s.path" :key="s.title")
      a(@click="setOpen()") {{s.title}}

</template>

<script>
export default {
  props: ['item'],
  data: () => ({
    open: false,
    active: false
  }),
  mounted() {
    if (this.$el.querySelector('.router-link-active')) {
      this.active = true
      this.open = true
    }
  },
  // needed for mobile version
  methods: {
    toggleOpen() {
      this.open = !this.open
    },
    // set active flag on child item click
    setOpen() {
      this.open = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nav/NavItem.vue